"use client"

import { BgColor } from "@/theme"
import clsx from "clsx"
import React from "react"

interface ToggleProps {
  checked: boolean
  onChange?: (checked: boolean) => void
  loading?: boolean
}

export const Toggle: React.FC<ToggleProps> = ({ checked, onChange, loading = false }) => {
  const toggleSwitch = () => {
    !loading && onChange?.(!checked)
  }

  return (
    <div
      onClick={toggleSwitch}
      className={clsx(
        `flex h-[26px] w-[48px] items-center rounded-full border px-[2px] py-[2px] transition-colors duration-300`,
        checked
          ? "border-primary-5 bg-primary-5 hover:border-primary-4 hover:bg-primary-4"
          : "border-bg-3 bg-bg-2 hover:bg-bg-3",
        loading ? "cursor-not-allowed" : "cursor-pointer"
      )}>
      <div
        style={{
          boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.15)",
        }}
        className={`h-[22px] w-[22px] transform rounded-full bg-bg-1 shadow-md transition-transform duration-300 ${
          checked ? "translate-x-[20px]" : ""
        }`}
      />
    </div>
  )
}
